import { useMemo } from 'react';
import { PriceValue } from '../../../../../../interfaces/product';

export const useSortedOffers = ({ prices, sort }: { prices?: PriceValue[]; sort: string }) => {
  const sortedPrices = useMemo(() => {
    if (prices) {
      if (sort === 'priceUp') {
        return [...prices].sort((a, b) => {
          const priceA = a.prices?.[0]?.price || null;
          const priceB = b.prices?.[0]?.price || null;
          if (priceA === null && priceB !== null) {
            return 1;
          }
          if (priceA !== null && priceB === null) {
            return -1;
          }
          if (priceA === null && priceB === null) {
            return 0;
          }
          if (priceA !== null && priceB !== null) {
            return priceA - priceB;
          }
          return 0;
        });
      }
      if (sort === 'stockQuantity') {
        return [...prices].sort((a, b) => {
          const stockA = a.vendor?.stock_quantity || null;
          const stockB = b.vendor?.stock_quantity || null;
          if (stockA === null && stockB !== null) {
            return 1;
          }
          if (stockA !== null && stockB === null) {
            return -1;
          }
          if (stockA === null && stockB === null) {
            return 0;
          }
          if (stockA !== null && stockB !== null) {
            return stockB - stockA;
          }
          return 0;
        });
      }
      if (sort === 'orderQuantity') {
        return [...prices].sort((a, b) => {
          const orderA = a.vendor?.order_quantity || null;
          const orderB = b.vendor?.order_quantity || null;
          if (orderA === null && orderB !== null) {
            return 1;
          }
          if (orderA !== null && orderB === null) {
            return -1;
          }
          if (orderA === null && orderB === null) {
            return 0;
          }
          if (orderA !== null && orderB !== null) {
            return orderB - orderA;
          }
          return 0;
        });
      }
      if (sort === 'deliveryPeriod') {
        return [...prices].sort((a, b) => {
          const deliveryA = a.vendor?.delivery_period || null;
          const deliveryB = b.vendor?.delivery_period || null;
          if (deliveryA === null && deliveryB !== null) {
            return 1;
          }
          if (deliveryA !== null && deliveryB === null) {
            return -1;
          }
          if (deliveryA === null && deliveryB === null) {
            return 0;
          }
          if (deliveryA !== null && deliveryB !== null) {
            return deliveryA - deliveryB;
          }
          return 0;
        });
      }
    }
    return [];
  }, [prices, sort]);

  return sortedPrices;
};
